import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { GuitarCrossMark } from './Logo';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const links = [{
    href: '#kdaj',
    label: 'Kdaj'
  }, {
    href: '#kje',
    label: 'Kje'
  }, {
    href: '#potrditev',
    label: 'Potrditev'
  }, {
    href: '#darilo',
    label: 'Darilo'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-[1100] transition-all duration-300 ${isScrolled ? 'bg-ivory/95 backdrop-blur-sm shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-90">
      <div className="max-w-5xl mx-auto px-6 flex justify-between items-center" data-id="element-91">
        <a href="#domov" className="flex items-center gap-2 group" aria-label="DANI 70 – še brca" data-id="element-92">
          <GuitarCrossMark color="#4A4B2F" className="h-8 w-8 transition-transform duration-300 group-hover:-translate-y-0.5" data-id="element-93" />
          <span className="font-serif text-xl font-semibold tracking-wide text-olive" data-id="element-94">
            DANI 70
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex space-x-8" data-id="element-95">
          {links.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-soft-brown hover:text-gold transition-colors tracking-wide" data-id="element-96">
              {link.label}
            </a>)}
        </div>

        {/* Mobile Nav Toggle */}
        <button className="md:hidden text-olive" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-97">
          {isMobileMenuOpen ? <X size={24} data-id="element-98" /> : <Menu size={24} data-id="element-99" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-ivory border-t border-olive/10 shadow-lg py-4 px-6 flex flex-col space-y-4" data-id="element-100">
          {links.map(link => <a key={link.href} href={link.href} className="text-base font-medium text-soft-brown hover:text-gold transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-101">
              {link.label}
            </a>)}
        </div>}
    </nav>;
}